import React from 'react';
import SubsectionProgress from './cssf-subsection-progress.component.js';
import styles from './cssf-section-progress.styles.css';
import { CprIcon } from 'canopy-styleguide!sofe';
import { navigate } from '../../source-forms/sections/section.helper.js';
import { Link, withRouter } from 'react-router-dom';

export function SectionProgress(props) {
  const complete = props.section.completed;
  return (
    <div className={styles.sectionProgress}>
      <Link
        to=""
        onClick={e =>
          navigate(props.surveyId, e, () =>
            props.history.push(props.getSubLink(0))
          )
        }
        className={styles.section}
        style={{ textDecoration: 'none', outline: 'none' }}>
        <div
          className={`${styles.header} ${
            complete ? '' : 'cps-bg-color-athens'
          }`}>
          {complete ? (
            <CprIcon
              name="checkmark-circle-filled-large"
              className="cps-color-success"
              size="28"
            />
          ) : (
            <span style={{ marginTop: '-1px' }}>{props.sectionIndex + 1}</span>
          )}
        </div>
        <span
          className={
            props.activeSection == props.section.id ? 'cps-color-primary' : ''
          }>
          {props.section.name}
        </span>
      </Link>
      <div className={`${styles.subsections}`}>
        {props.expanded &&
          props.section.subSections.map((subsection, index) => {
            return (
              subsection.visible && (
                <div key={subsection.name}>
                  <SubsectionProgress
                    subLink={props.getSubLink(index)}
                    surveyId={props.surveyId}
                    subsection={subsection}
                    active={
                      props.activeSubsection == index &&
                      props.activeSection == props.section.id
                    }
                  />
                </div>
              )
            );
          })}
      </div>
    </div>
  );
}

export default withRouter(SectionProgress);
